<template>
  <mobile-float-menu header>
    <template v-slot:content>
      <LoadPage :pages='pages' />
    </template>
  </mobile-float-menu>
</template>

<script>
  import LoadPage from "@/components/LoadPage.vue";
  import MobileFloatMenu from "@/components/MobileFloatMenu";
  export default {
    components: {
      LoadPage,
      MobileFloatMenu,
    },
    data() {
      return {
        pages: {
          es: '600617a8bcd3f20017c82516',
          en: '600617babcd3f20017c82518',
        }
      }
    },
  }
</script>